import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { take } from 'rxjs/operators';
import { Subscription, timer } from 'rxjs';
import { UserService } from 'app/core/user/user.service';

@Component({
  selector: 'app-logout-alert',
  templateUrl: './logout-alert.component.html',
  styleUrls: ['./logout-alert.component.scss']
})
export class LogoutAlertComponent implements OnInit {
  counter: number = 0;
  countDown: Subscription;
  constructor(
    private _dialogRef: MatDialogRef<LogoutAlertComponent>,
    private _localStorageService: LocalStorageService,
    private _userService: UserService
    ) { }

  ngOnInit(): void {
    this.counter = 6;
    this.countDown = timer(0, 1000)
                    .pipe(take(this.counter))
                    .subscribe(()=>{
                      --this.counter;
                      if(this.counter === 0){
                        this._dialogRef.close();
                        this.countDown.unsubscribe();
                        this._userService.signOut();
                      }
                    });
  }

}
